import request from '../utils/request';
import { IResult } from '../global';

const voteApi = {
  one: (id: string | number, force?: boolean) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url:
          '/api/v2/votes/getone?id=' +
          id +
          '&_with=vote_count_detail' +
          (force ? `&_t=${Date.now()}` : ''),
        method: 'get',
        headers: {
          Authorization: request.token
        }
      }).then(res => {
        if (!res.error) {
          resolve(res);
        } else {
          reject();
        }
      });
    });
  },
  addRecord: (vote_id: number, vote_value: string) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/voterecord/add?order_id=${window.gallery.orderid}&gallery_id=${window.gallery.id}`,
        method: 'POST',
        data: {
          vote_id,
          vote_value
        },
        headers: {
          Authorization: request.token
        }
      })
        .then(resolve)
        .catch(reject);
    });
  },
  voteToday: (id: number)=>{
    return new Promise<IResult>((resolve, reject)=>{
      request({
        url:`/api/v2/voterecord/todaychance`,
        mehotd:'get',
        data:{
          vote_id:Number(id)
        },
        headers: {
          Authorization: request.token
        }
      }).then(resolve).catch(reject);
    })
  },
  voted: (ids: any[]) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/voterecord/self`,
        method: 'get',
        data: {
          ids: (ids || []).join(',')
        },
        headers: {
          Authorization: request.token
        }
      })
        .then(resolve)
        .catch(reject);
    });
  }
};

export default voteApi;
